import { useNavigate, useLocation } from "react-router-dom";
import { Home, Compass, Play, User } from "lucide-react";
import { motion } from "framer-motion";

const TABS = [
  { path: "/", label: "Home", icon: Home, testid: "nav-home" },
  { path: "/search", label: "Find", icon: Compass, testid: "nav-search" },
  { path: "/setup", label: "Play", icon: Play, testid: "nav-play" },
  { path: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-slate-950 border-t border-slate-800 flex justify-around px-2 py-3 z-50"
    >
      {TABS.map((t) => {
        const active = location.pathname === t.path;
        const Icon = t.icon;
        return (
          <motion.button
            key={t.path}
            data-testid={t.testid}
            whileTap={{ scale: 0.88 }}
            onClick={() => navigate(t.path)}
            className="flex flex-col items-center gap-1 flex-1 no-tap-highlight"
          >
            <Icon
              className={active ? "text-amber-400" : "text-slate-500"}
              strokeWidth={2.5}
              size={24}
            />
            <span className={`text-[10px] font-bold uppercase tracking-wider ${active ? "text-amber-400" : "text-slate-500"}`}>
              {t.label}
            </span>
          </motion.button>
        );
      })}
    </nav>
  );
}
